"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return rpdf_renderer_1.View; } });
//# sourceMappingURL=view.js.map